import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TasksActionsTypesRoutingModule } from './tasks-actions-types-routing.module';
import { TasksActionsTypesListComponent } from './tasks-actions-types-list/tasks-actions-types-list.component';
import { TasksActionsTypesDetailComponent } from './tasks-actions-types-detail/tasks-actions-types-detail.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [TasksActionsTypesListComponent, TasksActionsTypesDetailComponent],
  imports: [
    CommonModule,
    TasksActionsTypesRoutingModule,
    FormsModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    CardModule,
    FontAwesomeModule,
    ConfirmDialogModule,
    DropdownModule,
    RouterModule,
    TranslateModule
  ],
  exports:[
    TasksActionsTypesListComponent,
    TasksActionsTypesDetailComponent
  ]
})
export class TasksActionsTypesModule { }
